export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Jueves_banner.abf15a81.png";